import { useEffect } from 'react';
import {
  useLocation,
  NavigateFunction,
  useNavigate,
  Location,
} from 'react-router-dom';
import { useApolloClient, useReactiveVar } from '@apollo/client';

import { signInStateVar } from 'approot/shared/user/user-data.apollo';
import { PUBLIC_SIGNIN, PUBLIC_STUDENTS } from 'global/public-routes.constants';
import { setSigninRedirectionPathForSession } from 'lib/session/session-storage';

export function goToSignIn(
  client: any,
  redirectPath: string,
  navigate: NavigateFunction,
  location: Location
) {
  if (location.pathname.startsWith(PUBLIC_SIGNIN)) {
    // we already are on the signin page
    return true;
  }

  setSigninRedirectionPathForSession(
    redirectPath ? redirectPath : `${location.pathname}${location.search}`
  );
  navigate(PUBLIC_SIGNIN, { replace: true });
}

// This hook will listen to changes in the sign in state.
const useCheckAuthBeforeMount = (
  isAuthenticatedRoute: boolean = false,
  isStudentRoute: boolean,
  redirectPath: string = ''
) => {
  const client = useApolloClient();
  const navigate = useNavigate();
  const location = useLocation();

  const { isSignedIn, isStudentSignedIn } = useReactiveVar(signInStateVar);

  useEffect(() => {
    if (isAuthenticatedRoute && isStudentRoute && !isStudentSignedIn) {
      // redirect to student signin screen
      navigate(PUBLIC_STUDENTS, { replace: true });
    } else if (isAuthenticatedRoute && !isStudentRoute && !isSignedIn) {
      // redirect to standard signin screen
      goToSignIn(client, redirectPath, navigate, location);
    }
    //eslint-disable-next-line
  }, [isSignedIn, isStudentSignedIn]);

  return {
    isSignedIn,
    isStudentSignedIn,
  };
};

export default useCheckAuthBeforeMount;
